/*GET ALL BOOKINGS */
export const Error_Request = "Error_Request" 
export const Error_Reset = "Error_Reset"
 